import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Wrap = styled.div`
  padding-bottom: 40px;
`;

export const NoResultsWrap = styled.div`
  margin: 0 30px;

  @media ${minBp('tabletLarge')} {
    margin: 0 100px;
  }
`;
